/**
 * Achat EXPRESS d'un pack ou d'un programme depuis le site (`/programmes/…`) :
 * `/debloquer/pack/{packId}` ou `/debloquer/programme/{packId}` (le programme
 * en vigueur qui contient ce pack). Connexion / inscription sur place puis
 * départ direct vers le paiement, sans repasser par la page d'une carte.
 * Règles PURES, testées.
 */

import type { SkillcardQuote } from '@jeraisonne/db/cards';
import type { PackOffers } from './purchase';

export const EXPRESS_OFFERS = ['pack', 'programme'] as const;
export type ExpressOffer = (typeof EXPRESS_OFFERS)[number];

export function isExpressOffer(v: unknown): v is ExpressOffer {
  return v === 'pack' || v === 'programme';
}

export function expressBuyPath(offer: ExpressOffer, packId: string): string {
  return `/debloquer/${offer}/${packId}`;
}

/** Devis de l'offre demandée (pack entier ou programme de l'année). */
export function expressQuote(data: PackOffers, offer: ExpressOffer): SkillcardQuote | null {
  return offer === 'pack' ? data.pack_offer : data.programme_offer;
}

/**
 * Déjà débloqué (rien à payer) : toutes les cartes du lot possédées, ou accès
 * qui les couvre (abonnement, pass, admin ; « owned » ne couvre que le pack).
 */
export function expressUnlockedLabel(
  offer: ExpressOffer,
  quote: Pick<SkillcardQuote, 'cards_to_buy'>,
  access: string | null,
): string | null {
  if (access === 'subscription') return 'Ton abonnement inclut déjà ces SKILLCARDS';
  if (access === 'pass') return 'Ton accès en cours inclut déjà ces SKILLCARDS';
  if (access === 'admin') return 'Accès administrateur : rien à acheter';
  if (quote.cards_to_buy <= 0 || (offer === 'pack' && access === 'owned')) {
    return offer === 'pack'
      ? 'Ce pack est déjà débloqué : ses SKILLCARDS sont dans ton deck'
      : 'Ce programme est déjà débloqué : ses SKILLCARDS sont dans ton deck';
  }
  return null;
}

/** Où aller après le paiement : l'espace du compte. */
export function expressReturnPath(role: string | null | undefined): string {
  return role === 'player' ? '/player/skillcards' : '/student/progression';
}
